import React, { FC, useState } from 'react';
import ProductTile, { ProductTileProps } from '../../shared/common/ProductTile';
import { CopyDetailsPopup } from '../../yourborrowbox/collection/copyDetailsPopup/CopyDetailsPopup';
import { ProductMetaData } from '../../../models/Product';
import { Article } from '../../../models/Article';
import { Button, ButtonSize, ButtonTheme } from '../../shared/common/Button';
import { MATERIAL_ICON_SETTINGS } from '../../shared/common/Button/Icon';
import { useTranslation } from 'react-i18next';

type Props = Omit<ProductTileProps, 'showSelectedPriceOnly' | 'allowPriceSelection' | 'onSelectPrice'>;

export const CatalogueProductTile: FC<Props> = props => {
    const [selectedProduct, setSelectedProduct] = useState<(ProductMetaData & Article) | null>(null);
    const { t } = useTranslation();

    const { product, onAddPrice } = props;

    return (
        <>
            {selectedProduct ? (
                <CopyDetailsPopup
                    onClosePopup={() => setSelectedProduct(null)}
                    onAddPrice={onAddPrice}
                    product={selectedProduct}
                    shopLanguage={props.shopLanguage}
                />
            ) : null}
            <ProductTile
                {...props}
                showSelectedPriceOnly={false}
                allowPriceSelection={true}
                onAddPrice={onAddPrice}
                onSelectPrice={async () => {}}
            >
                <Button
                    text={t('manage')}
                    onClick={() => setSelectedProduct(product)}
                    icon={MATERIAL_ICON_SETTINGS}
                    size={ButtonSize.SMALL}
                    theme={ButtonTheme.NEUTRAL}
                    fullWidth={true}
                    className="my-3"
                />
            </ProductTile>
        </>
    );
};
